import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Rendu Markdown (GFM) homogène pour l'admin : aperçus de descriptions,
 * stream de l'assistant IA, etc. Styles portés par la classe `.md` (index.css).
 */
export function Markdown({
	children,
	className,
}: {
	children: string;
	className?: string;
}) {
	return (
		<div className={className ? `md ${className}` : "md"}>
			<ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
		</div>
	);
}
